import React from 'react';
import { Route, Routes } from 'react-router-dom';
import { ProtectedRoute } from '../context/ProtectedRoute';
import BelcoladeDashboard from '../projects/ESID-24-003/pages/dashboard';
import BelcoladeReport from '../projects/ESID-24-003/pages/report';
import BelcoladeCustom from '../projects/ESID-24-003/pages/custom';
import Management from '../projects/ESID-24-003/pages/management';

function BelcoladeRoutes({setLoading, triggerAlert}) {
  return (
    <Routes>
      <Route path="dashboard" element={
        <ProtectedRoute project="esid-24-003" >
          <BelcoladeDashboard setLoading={setLoading} triggerAlert={triggerAlert} />
        </ProtectedRoute>
      } />
      <Route path="reports" element={
        <ProtectedRoute project="esid-24-003" >
          <BelcoladeReport setLoading={setLoading} triggerAlert={triggerAlert} />
        </ProtectedRoute>
      } />
      <Route path="custom" element={
        <ProtectedRoute project="esid-24-003" >
          <BelcoladeCustom setLoading={setLoading} triggerAlert={triggerAlert} />
        </ProtectedRoute>
      } />
      <Route path="management" element={
        <ProtectedRoute project="esid-24-003">
          <Management setLoading={setLoading} triggerAlert={triggerAlert} />
        </ProtectedRoute>
      } />
    </Routes>
  );
}

export default BelcoladeRoutes;